import Vue from "vue";

// 识别所有文件注册组件，并用name作为组件名称
const files = require.context("../components", true, /index\.vue$/);
files.keys().forEach((key) => {
  const content = files(key).default || files(key);
  Vue.component(content.name, content);
});
